import { createFileRoute } from "@tanstack/react-router";
import { OverworldScreen } from "@ui/screens/OverworldScreen";

export const Route = createFileRoute("/overworld")({
  component: OverworldScreen,
});
